import { uid } from '@/firebase'
import mixpanel from 'mixpanel-browser'

export class Mixpanel {
  // staging 等トークン未設定の環境では mixpanel.init() を呼んでいないため、
  // identify()/track() を実行すると未初期化エラーで落ちる。トークンが無い場合は
  // 一切 mixpanel を触らない。
  private static get enabled() {
    return !!import.meta.env.VITE_APP_MIXPANEL_TOKEN
  }

  static identify() {
    if (!this.enabled) {
      return
    }
    const uidResult = uid()
    if (!uidResult) {
      return
    }
    mixpanel.identify(uidResult)
  }

  private static track(event: string, properties?: Record<string, unknown>) {
    if (!this.enabled) {
      return
    }
    this.identify()
    mixpanel.track(event, properties)
  }

  /**
   * オンボーディング
   */
  static trackDisplayWelcomModal() {
    this.track('ようこそモーダル表示')
  }

  static trackTryBookingStart() {
    this.track('体験調整_開始')
  }

  static trackTryBookingSelectDateTime() {
    this.track('体験調整_日時選択')
  }

  static trackTryBookingComplete() {
    this.track('体験調整_完了')
  }

  /**
   * 重要なお知らせモーダル
   */
  static trackImportantNoticeClose(noticeId: string, title: string | null) {
    this.track('重要なお知らせ_閉じた', { noticeId, title })
  }

  static trackImportantNoticeClickUrl(noticeId: string, title: string | null) {
    this.track('重要なお知らせ_リンク押下', { noticeId, title })
  }
}
